import {ErrorComponentProps} from '@tanstack/react-router';
import {useEffect} from 'react';

export function RenderNothing() {
  return null;
}

export function RouteErrorComponent({error}: ErrorComponentProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <>
    <p>Element konnte nicht geladen werden.</p>
    <p>Wenn das Problem weiterhin besteht wenden Sie sich bitte an Ihren Administrator.</p>
  </>;
}
